import { useEffect } from "react";

// Set document.title + meta description per page. Titles/descriptions are the
// snippet Google shows in results, so pages that rank but get no clicks
// (partnership, geography) need compelling ones.
export function usePageSeo(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [title, description]);
}
